import { DEMO_NAME_PREFIX } from './constants'

/**
 * Returns true when a customer record represents a demo customer.
 *
 * Prefers a dedicated backend `isDemo` flag (not yet surfaced by
 * GET /customers/:id today) and falls back to a name-prefix check so
 * the detection keeps working until the backend adds the field.
 *
 * Matches the defensive pattern used by `isTestCompany` elsewhere in
 * the codebase (e.g. BenefitsTable/helpers.tsx).
 */
export function isDemoCustomer(customer?: {
  name?: string
  isDemo?: boolean
}): boolean {
  if (!customer) return false
  return (
    customer.isDemo === true ||
    Boolean(customer.name?.startsWith(DEMO_NAME_PREFIX))
  )
}
